

export class DocumentTypeUpdateInput implements IDocumentTypeUpdateInput {
    /** The auto-generated id of the document type master */
    documentTypeId!: number;
    /** The  document type name with 255 character limit */
    documentTypeName!: string;

    constructor(data?: IDocumentTypeUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
        }
    }

    static fromJS(data: any): DocumentTypeUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        return data; 
    }
}

export interface IDocumentTypeUpdateInput {
    /** The auto-generated id of the document type master */
    documentTypeId: number;
    /** The  document type name with 255 character limit */
    documentTypeName: string;
}

